/**
 * hlsKey
 *
 *  ...secure key managment
 *
 */
'use strict';

import Utils from '../HlsUtils';
import '../utils/ObjectAssignPolyfill';
import _ from 'lodash';
import DetectBrowser from './detectBrowser';
import DataTypes from '../hlsjs/data-types';


let _hlsKeyRef = null;
/**
* @access internal
*/
class HlsKey {

	constructor(downloader, config = {} ) {
		this._downloader = downloader;
		this._keys = [];
		this._pendedLoads = [];
		this._inLoad = false;
		this._browDetected = DetectBrowser;

		if (this._browDetected.name === 'node') {
			this._transType = 'array';
		}
		else {
			this._transType = 'arraybuffer';
		}

		Utils.applyConfig(this, config);

		_hlsKeyRef = this;
	}


	dispose() {
	}


	destroy() {
	}

	get downloader() {
		return this._downloader;
	}


	set downloader(downloader) {
		this._downloader = downloader;
		return this._downloader;
	}


	_getCypher(url) {
		let foundkey = undefined;
		let returnval = undefined;

		let gettingFind = function (x) {
			return x.url === url;
		};

		foundkey = _.find(this._keys, gettingFind);

		if (foundkey === undefined) {
			let getCypherThat = this;

			//console.log( url + ' not in cache. Starting load ***************************************************');

			let cypher = new Promise(function (resolve, reject) {

				let cypherGot = function ( response ) {
					getCypherThat._inLoad = false;
					//console.log( response.url + ' cypherGot ***************************************************');
					if (response === undefined) reject(-1);
					else resolve(response.data);


					//console.log( getCypherThat._pendedLoads.length + ' pended loads ***************************************************');

					if (getCypherThat._pendedLoads.length !== 0) {
						let pendedLoad = getCypherThat._pendedLoads.shift();

						//console.log( pendedLoad.url + ' load now ***************************************************');

						getCypherThat.loadKeyIn(pendedLoad.url, pendedLoad.finishedCallback, pendedLoad.timeoutCallback, pendedLoad.getCypherThat);
					}
				};

				let cypherTimeout = function ( ) {
					getCypherThat._inLoad = false;
					//console.log( ' cypherTimeout ***************************************************');
					reject(-1);
				};

				getCypherThat.loadKeyIn(url, cypherGot, cypherTimeout, getCypherThat);
			});

			this._keys.push( {
				url: url,
				cypher: cypher,
			});

			returnval = cypher;
		}
		else {
			//console.log(this._keys.length + ' keys in cache, Found! ***************************************************');
			returnval = foundkey.cypher;
		}

		return returnval;
	}


	getCypher(url) {

		let getCypherThat = this;

		let gettingCypher = new Promise(function (resolve, reject) {


			getCypherThat._getCypher(url).then( (data) => resolve(data) )
			.catch((err) => reject(err));

//			if (returnval === undefined) reject(-1);  //this is only checking if the passed back promise is one
//			else resolve(returnval);
		});

		return gettingCypher;
	}



	get length() {
		return this._keys.length;
	}



	hlsKeyLoadCallback( context, callbacks ) {

		//console.log('hlsKeyLoadCallback ' + context.url + '***************************************************');

		_hlsKeyRef.getCypher(context.url).then( (data) => callbacks.onSuccess(data) )
		.catch((err) => callbacks.onError(null, new Error('Could not load key ' + err)));
	}



	loadKeyIn(url, finishedCallback, timeoutCallback, getCypherThat) {

		if (!getCypherThat._inLoad) {
			getCypherThat._inLoad = true;


			//console.log( getCypherThat._downloader );

			//console.log( url + ' loadKeyIn ***************************************************');

			let loaderContext = { url : url, responseType: getCypherThat._transType, dataType : DataTypes.KEY };
			let loaderConfig = {
				timeout: 10000, //config.fragLoadingTimeOut,
//				maxRetry : config.fragLoadingMaxRetry,
//				retryDelay : config.fragLoadingRetryDelay,
//				maxRetryDelay : config.fragLoadingMaxRetryTimeout,
			};

			let loaderCallbacks = { onSuccess : finishedCallback.bind(getCypherThat), onTimeout : timeoutCallback.bind(getCypherThat) };
			//, onError :this.loaderror.bind(getCypherThat), onTimeout : this.loadtimeout.bind(getCypherThat)



			//console.log( 'downloader *********************' + getCypherThat._downloader );

			getCypherThat._downloader.load(loaderContext, loaderConfig, loaderCallbacks);
		}
		else {
			//console.log( url + ' pended loadKeyIn ***************************************************');

			getCypherThat._pendedLoads.push( {
				url,
				finishedCallback,
				timeoutCallback,
				getCypherThat,
			});
		}
	}



}
export default HlsKey;



// WEBPACK FOOTER //
// ./src/utils/hlsKey.js